"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.weak-map.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.set.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _constants = require("./constants");

var _unsubscribe = _interopRequireWildcard(require("./unsubscribe"));

var _tools = require("./tools");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var subscribe = function subscribe(deps, callback) {
  var callWhenSub = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!(0, _tools.isArray)(deps)) {
    throw new Error("Error: the first param must be array\uFF01".concat(deps));
  }

  if (typeof callback !== 'function') {
    throw new Error("Error: the second param muse be function! ".concat(callback));
  }

  var copyDeps = deps;
  var initialDepsValue = [];

  for (var i = 0; i < copyDeps.length; i += 1) {
    var dep = copyDeps[i];

    if (typeof dep !== 'function') {
      console.trace();
      throw new Error("Error: dependency ".concat(dep, ", is not function."));
    }

    if (dep[_constants.gluerUniqueFlagKey] !== _constants.gluerUniqueFlagValue) {
      console.error("Warning: dependency ".concat(dep, ", is not defined by gluer. Please check it!"));
    }

    initialDepsValue.push(dep());
  }

  ;
  var setDeps = copyDeps.length !== 0;

  if (setDeps) {
    if (_unsubscribe.depsToFnMap.has(copyDeps)) {
      var result = _unsubscribe.depsToFnMap.get(copyDeps);

      result.add(callback);
    } else {
      _unsubscribe.depsToFnMap.set(copyDeps, new Set([callback]));
    }

    for (var _i = 0; _i < copyDeps.length; _i += 1) {
      var _dep = copyDeps[_i];

      if (_unsubscribe.refToDepsMap.has(_dep)) {
        var value = _unsubscribe.refToDepsMap.get(_dep);

        value.add(copyDeps);
      } else {
        _unsubscribe.refToDepsMap.set(_dep, new Set([copyDeps]));
      }
    }
  }

  if (callWhenSub) {
    callback.apply(void 0, initialDepsValue);
  }

  return function () {
    if (setDeps) {
      (0, _unsubscribe.default)(copyDeps, callback);
    }
  };
};

var _default = subscribe;
exports.default = _default;